import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {RenderService} from './render.service';
import {OrbitControlsService} from '../Control/orbit-controls.service';
import {MouseControlsService} from '../Control/mouse-controls.service';
import {StartUp} from './start-up';
import {EditorControlService} from '../../API/Public/editor-control.service';
import {LoaderService} from './loader.service';

@Component({
    selector: 'surface-canvasRenderer',
    templateUrl: './canvas-renderer.component.html',
    styleUrls: ['./canvas-renderer.component.css']
})
export class CanvasRendererComponent implements OnInit, AfterViewInit {
    @Input() reload: boolean;
    private boundingRect: DOMRect;
    private zoomTarget = null;
    @ViewChild('canvas', {static: true})
    private canvasRef: ElementRef;
    private _blockPan = false;

    constructor(public startUpService: StartUp,
                private renderService: RenderService,
                private orbitControlsService: OrbitControlsService,
                private mouseControlService: MouseControlsService,
                private loaderService: LoaderService,
                public editorControlService: EditorControlService) {

    }

    ngOnInit() {
        if (this.reload && !this.loaderService.singelton) {
            this.startUpService.initScene();
            this.loaderService.singelton = true;
        }
    }

    /**
     * returns the current canvas
     */
    private get canvas(): HTMLCanvasElement {
        return this.canvasRef.nativeElement;
    }

    ngAfterViewInit() {
        this.canvas.width = this.canvas.clientWidth;
        this.canvas.height = this.canvas.clientHeight;
        this.startUpService.initRenderer(this.canvas, this.reload);
        this.orbitControlsService.initControls(this.renderService.renderer);
        if (!this.reload) {
            this.startUpService.initScene();
        }
        this.renderService.render();
    }

    /**
     * if window is changed, or loaded the canvas view has to be resized and adopted to the screen size
     * @param init
     */
    public onResize(init = false) {
        const width = this.canvas.clientWidth;
        const height = this.canvas.clientHeight;
        this.startUpService.setCanvasSize(width, height);
        if (this.canvas.width !== width || this.canvas.height !== height || init) {
            this.boundingRect = this.canvas.getBoundingClientRect();
            this.renderService.onResize(width, height);
        }
    }

    /**
     * Model move --> listens on right mouse event
     * @param event: MouseEvent
     */
    onMouseMove(event: MouseEvent) {
        this.mouseControlService.mouseMove(this.mouseControlService.getSrcEvent(event, this.canvas, this.boundingRect));
    }

    /**
     * Pointer move for painting, model rotation
     * @param event
     */
    public onPanMove(event) {
        if (event.pointerType !== 'mouse' && !this._blockPan) {
            this.mouseControlService.mouseMove(this.mouseControlService.getSrcEvent(event, this.canvas, this.boundingRect));
        }

    }

    /**
     * is called if pointer movement is finished (paint end)
     * @param event
     */
    public onPanEnd(event) {
        if (!this._blockPan) {
            console.log('mouseup');
            this.mouseControlService.mouseUp(this.mouseControlService.getSrcEvent(event, this.canvas, this.boundingRect));
        }
    }

    /**
     ** Pointer Down
     * @param event
     */
    public onPanStart(event) {
        // if (this.editorControlService.event !== EditorControls.measure &&
        //     this.editorControlService.event !== EditorControls.placeLandmarks &&
        if (!this._blockPan) {
            this.mouseControlService.mouseDown(this.mouseControlService.getSrcEvent(event, this.canvas, this.boundingRect));
        }
    }

    /**
     * is called if two short mouse clicks are fired --> sets rotation point
     * @param event
     */
    public onTap(event) {
        if (event.tapCount === 2) {
            this.mouseControlService.dblClick(this.mouseControlService.getSrcEvent(event, this.canvas, this.boundingRect));
        } else if (event.pointerType !== 'mouse') {
            this.onMouseDown(event);
            this.onMouseUp(event);
        }
    }

    /**
     * listens on double touch --> sets rotation point
     * @param event
     */
    public onDblTouch(event) {
        // needed for pan to work
        if (this.boundingRect === undefined) {
            this.boundingRect = this.canvas.getBoundingClientRect();
        }

        this.zoomTarget = event.pointers;
        if (event.touches.length > 1) {
            this.mouseControlService.dblTouch(<PointerEvent>this.mouseControlService
                .convertToMouseEvent(event, this.canvas, this.boundingRect));
        }
    }

    // /**
    //  * if mouse wheel is fired, the model is zoomed to current mouse position
    //  * @param event
    //  */
    // public zoomMouse(event) {
    //     this.mouseControlService.zoomTargetforMouse(event);
    // }


    /**
     * left mouse button clicked
     * @param event
     */
    onMouseDown(event: MouseEvent) {
        this.mouseControlService.mouseDown(this.mouseControlService.getSrcEvent(event, this.canvas, this.boundingRect));
    }

    /**
     * right mouse event is finished
     * @param event
     */
    onMouseUp(event: MouseEvent) {
        this.mouseControlService.mouseUp(this.mouseControlService.getSrcEvent(event, this.canvas, this.boundingRect));
        if (event.buttons === 2) {
            this.mouseControlService.mouseUp(event);
        }
    }

    /**
     * move model --> change camera offset
     * @param event
     */
    onTouchModelMove(event) {
        if (event.touches.length > 1) {
            // prevent accidental draw after two finger rotation
            this._blockPan = true;

            this.mouseControlService.mouseMove(this.mouseControlService.convertToMouseEvent(event, this.canvas, this.boundingRect));
        }
    }

    /**
     * move model End --> sets camera offset
     * @param event
     */
    onTouchModelMoveEnd(event) {
        // allow drawing again after two finger rotation
        if (event.touches.length === 0) {
            this._blockPan = false;
        }

        if (event.touches.length > 1) {
            this.mouseControlService.mouseUp(this.mouseControlService.convertToMouseEvent(event, this.canvas, this.boundingRect));
        }
    }

}
